import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import {
    SprayApplicationRate,
    SprayProductPerUnitType,
    SprayProductUnits
} from 'services/sprayEvents/types';
import { ProductId } from 'services/products/types';
import { AppState } from 'services/types';
import { UnitTypeId } from 'services/unitTypes/types';
import { makeSelectProductFieldValue } from 'services/products/selectors';
import ProductRateFieldValue from './components/ProductRateFieldValue';

interface ConnectedProps {
    unitTypeId: UnitTypeId;
}

export interface OwnProps {
    applicationRate: SprayApplicationRate;
    units: SprayProductUnits;
    productId: ProductId;
    perUnitType: SprayProductPerUnitType;
}

export type Props = OwnProps & ConnectedProps;

export class ProductRateFieldComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const {
            unitTypeId,
            applicationRate,
            productId,
            units,
            perUnitType
        } = this.props;

        return (
            <div className="field">
                {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
                <label htmlFor="ratePerHundredLitre">
                    <span
                        className="read-only-field no-label"
                        id="ratePerHundredLitre"
                    >
                        <ProductRateFieldValue
                            perUnitType={perUnitType}
                            unitTypeId={unitTypeId}
                            applicationRate={applicationRate}
                            productId={productId}
                            units={units}
                        />
                    </span>
                </label>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    unitTypeId: makeSelectProductFieldValue('unitTypeId')
});

export default connect(mapStateToProps)(ProductRateFieldComponent);
